export default __webpack_public_path__ + "static/media/about2.86f42b7e.jpg";